module.exports = __webpack_public_path__ + "assets/2d1aef5a5fca0e62caa90a6328eae5d8.png";